export default __webpack_public_path__ + "static/media/pic_4.93ae0612.JPG";